import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B07InvoicePage } from '../b07-invoice/b07-invoice';
import { B07aInvoiceInfoPage } from '../b07a-invoice-info/b07a-invoice-info';

/**
 * Generated class for the B07cInvoicePaymentPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface invoiceInfo{
  INVOICE_ID: number;
  DATETIME: string;
  GRANDTOTAL: number; 
  REMARKS: string; 
  FINALIZED_FLG: string; 

  INV_CORP_ID: number;  
  CORP_NAME: string;
  ACTION_BY: number;
  USER_ID: number;
  USER_NAME: string;
}

interface invoiceLineInfo{
  INVOICE_LINE_ID: number;
  INVOICE_ID: number;
  CARD_ID: number;
  CARD_NO: number;
  CREDIT_LIMIT: number;
  USED_CREDIT: number;
  CARD_PAYMENT: number;
  TOTAL_CARD_PAYMENT: number;
  TEMP_TOTAL_CARD_PAYMENT: number;
}

interface invoicePaymentInfo{
  INVOICE_PAYMENT_ID: number;
  INVOICE_ID:number;
  INVOICE_LINE_ID: number;
  CARD_ID: number;
  CARD_PAYMENT: number;
  TOTAL_CARD_PAYMENT: number;
}

@IonicPage()
@Component({
  selector: 'page-b07c-invoice-payment',
  templateUrl: 'b07c-invoice-payment.html',
})
export class B07cInvoicePaymentPage {

  private todo : FormGroup;
  loading: any;
  Status: any;
  invoiceArr: invoiceInfo[] = [];
  invoiceItems: invoiceInfo[] = [];
  invoiceLineArr: invoiceLineInfo[] = [];
  invoiceLineItems: invoiceLineInfo[] = [];
  invoicePaymentArr: invoicePaymentInfo[] = [];
  invoicePaymentItems: invoicePaymentInfo[] = [];
  public errorMessage: any = "";

  invoiceData = { INVOICE_ID:'', DATETIME:'', 
                  GRANDTOTAL:'', REMARKS:'', SUB_TOTAL:'', TAX:'', FINALIZED_FLG:'', 
                  INV_CORP_ID:'', ACTION_BY:'',
  }

  INVOICE_ID:any;
  USER_ID: any;
  taxTotal: any;
  CORP_NAME: any;
  totalCard: any;
  finalizedFlg: any;
  totalPayment: any = 0;
  Balance: any = 0;

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public serviceapi: ServiceApiProvider,
              public loadingCtrl: LoadingController, public alertCtrl : AlertController) {

    this.todo = this.formBuilder.group({
      remark: [''],
      corporate: ['', Validators.required],
    });

    this.INVOICE_ID = this.navParams.get('paramID');    //invoice ID
    this.USER_ID = sessionStorage.getItem('userid');

    let tbl = ["INVOICE"];
    let column = ["INVOICE_ID"];
    let value = [this.INVOICE_ID];
    
    let tblkey = ["INV_CORP_ID", "ACTION_BY"];
    let fktbl = ["CORPORATE", "USER"];
    let fkkey = ["CORP_ID", "USER_ID"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"INVOICE","1","1").then((result) => {
        
      this.Status = result["Message"];

      if (this.Status == "1"){

        let Records = result["Records"];

        this.invoiceData.INVOICE_ID = Records[0]["INVOICE_ID"];
        this.invoiceData.DATETIME = Records[0]["DATETIME"];
        this.invoiceData.REMARKS = Records[0]["REMARKS"];
        this.invoiceData.SUB_TOTAL = Records[0]["SUB_TOTAL"];
        this.invoiceData.TAX = Records[0]["TAX"];
        this.invoiceData.GRANDTOTAL = Records[0]["GRANDTOTAL"];
        this.invoiceData.FINALIZED_FLG = Records[0]["FINALIZED_FLG"];
        this.invoiceData.INV_CORP_ID = Records[0]["INV_CORP_ID"];
        this.invoiceData.ACTION_BY = Records[0]["ACTION_BY"];
        this.CORP_NAME = Records[0]["CORP_NAME"];

        this.finalizedFlg = this.invoiceData.FINALIZED_FLG;
        this.taxTotal = parseInt(this.invoiceData.TAX) * parseInt(this.invoiceData.SUB_TOTAL);                                 //get tax amount

        let tbl = ["INVOICE_LINE"];
        let column = ["INVOICE_ID"];
        let value = [this.INVOICE_ID];
        
        let tblkey = ["CARD_ID"];
        let fktbl = ["CARD"];
        let fkkey = ["CARD_ID"];

        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");

        this.serviceapi.readdata(json_data,"INVOICE_LINE","1","1").then((result) => {
            
          this.Status = result["Message"];

          if (this.Status == "1"){
            
            this.totalCard = result["RXData"];
            let Records = result["Records"];
            this.invoiceLineArr = Records;
            //this.invoiceLineItems = this.invoiceLineArr;

            for (let i=0; i<=(this.totalCard-1); i++)
            {
              this.invoiceLineArr[i].TOTAL_CARD_PAYMENT = 0;
              this.invoiceLineArr[i].CARD_PAYMENT = 0;

              let tbl = ["INVOICE_PAYMENT", "INVOICE_PAYMENT",];
              let column = ["CARD_ID", "INVOICE_ID",];
              let value = [this.invoiceLineArr[i].CARD_ID, this.invoiceLineArr[i].INVOICE_ID];
              
              let tblkey = ["No"];
              let fktbl = ["No"];
              let fkkey = ["No"];

              let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);
              let mydata = Object.assign(jsonitem);
              let json_data = this.serviceapi.json_readdata(mydata,"1");

              this.serviceapi.readdata(json_data,"INVOICE_PAYMENT","1","1").then((result) => {
                
                this.Status = result["Message"];

                if (this.Status == "1"){

                  let RxData = result["RXData"];
                  let Records = result["Records"];
                  this.invoicePaymentArr = Records;
                  this.invoiceLineArr[i].TOTAL_CARD_PAYMENT = this.invoicePaymentArr[RxData-1].TOTAL_CARD_PAYMENT;
                  this.totalPayment += +this.invoicePaymentArr[RxData-1].TOTAL_CARD_PAYMENT;
                }
                else {
                  if (this.Status!="4"){
                    this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                  }
                }

                if (i == (this.totalCard-1)){
                  this.Balance = parseFloat(this.invoiceData.GRANDTOTAL) - this.totalPayment;
                }
              }, (err) => {
                this.errorMessage = "Loading Error. Please try again.";

              });
            }
            this.invoiceLineItems = this.invoiceLineArr;
            this.loading.dismiss();
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            this.loading.dismiss();
          }
        }, (err) => {
            this.errorMessage = "Loading Error. Please try again.";
            this.loading.dismiss();
        });
        
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B07cInvoicePaymentPage');
  }

  update(){
    this.errorMessage = '';

    for (let i=0; i<=(this.totalCard-1); i++)
    {
      let tempTotalCardPayment = 0;
      tempTotalCardPayment = +this.invoiceLineArr[i].TOTAL_CARD_PAYMENT + this.invoiceLineArr[i].CARD_PAYMENT;

      if (tempTotalCardPayment > this.invoiceLineArr[i].USED_CREDIT) {
        this.errorMessage = "Card Payment more than Used Credit";
      }
      else {
        this.invoiceLineArr[i].TEMP_TOTAL_CARD_PAYMENT = tempTotalCardPayment;
      }
    }

    if (this.errorMessage == '') {                            //if no error
      let confirm = this.alertCtrl.create({
        title: 'Confirmation',
        message: 'Are you sure you want to update this invoice payment? This action cannot be undone.',
        buttons: [
          {
            text: 'No',
            handler: () => {
              console.log('Disagree clicked');
            }
          }, 
          {
            text: 'Yes',
            handler: () => {
              console.log('Agree clicked');
                
              this.showLoader();
  
              let value = this.SUBMIT_JSON(this.INVOICE_ID, this.USER_ID);

              this.serviceapi.invociepaymentdata(value).then((result) => {
                
                
                this.Status = result["Message"];
                console.log(this.Status);
                if (this.Status == '1'){
                  this.invoiceData.FINALIZED_FLG = this.finalizedFlg;
                  this.updateInvoice();
                }
                else {
                  this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
                  this.loading.dismiss();
                }
              }, (err) => {
                this.errorMessage = "Loading Error. Please try again.";
                this.loading.dismiss();
              });
            }
          }
        ]
      });
      confirm.present();
    }
    
  }

  SUBMIT_JSON(INVOICE_ID, USERID)
  {
      let COMPILE_DATA = {
				Param:"",
        INVOICE_ID:"",
        CARD_ID:[],
        INVOICE_LINE_ID:[],
        CARD_PAYMENT:[],
				TOTAL_CARD_PAYMENT:[],
				UserID: ""
      }

      let invoiceLineTotal = (this.invoiceLineArr).length;
      this.finalizedFlg = 'Completed';
      
      for(let i=0;i<invoiceLineTotal;i++)
      {
        COMPILE_DATA.CARD_ID.push(this.invoiceLineArr[i].CARD_ID);
        COMPILE_DATA.INVOICE_LINE_ID.push(this.invoiceLineArr[i].INVOICE_LINE_ID);
        COMPILE_DATA.CARD_PAYMENT.push(this.invoiceLineArr[i].CARD_PAYMENT);
        COMPILE_DATA.TOTAL_CARD_PAYMENT.push(this.invoiceLineArr[i].TEMP_TOTAL_CARD_PAYMENT);

        console.log(this.invoiceLineArr);
        if (this.invoiceLineArr[i].TOTAL_CARD_PAYMENT < this.invoiceLineArr[i].USED_CREDIT){
          this.finalizedFlg = 'Partial Payment';
        }
      }

      COMPILE_DATA.Param = "2";                         //Param 2 for send array value
      COMPILE_DATA.INVOICE_ID = INVOICE_ID;
      COMPILE_DATA.UserID = USERID;

     return COMPILE_DATA;
  }

  updateInvoice(){
    
    this.serviceapi.updatedata('INVOICE', 'INVOICE_ID', this.INVOICE_ID, this.invoiceData).then((result) => {
        
      this.Status = result["Message"];
      if (this.Status == "1"){
        this.loading.dismiss();
        this.navCtrl.setRoot(B07InvoicePage);
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
        this.errorMessage = "Loading Error. Please try again.";
        this.loading.dismiss();
    });
  }

  cancel(){
    this.navCtrl.pop();
  }

  goTo(){
    this.navCtrl.setRoot(B07InvoicePage);
  }

  goTo2(){
    this.navCtrl.setRoot(B07aInvoiceInfoPage, {paramID: this.INVOICE_ID});
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b07c-invoice-payment/b07c-invoice-payment.ts